// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {
    // Bootstrap matching Media Queries
    //To use:
    //      Pass mediaQueries into module function: extranet.Utilities.function(mediaQueries)
    //      In module function:
    //          if(mediaQueries.sm.matches){
    //              code here
    //          }
    const mediaQueries = {
        sm: window.matchMedia('(min-width: 576px)'),
        md: window.matchMedia('(min-width: 768px)'),
        lg: window.matchMedia('(min-width: 992px)'),
        xl: window.matchMedia('(min-width: 1200px)'),
        xlDown: window.matchMedia('(max-width: 1199px)')
    }

    //------------------------------------------------------------------------//
    //  Initialize Lazyloading with support for native lazyload
    //
    //  Defaults to use lazyload plugin, but will fall back to native support 
    //  for browsers with support for the loading="lazy" attribute
    //  (https://caniuse.com/#feat=loading-lazy-attr)
    //------------------------------------------------------------------------//
    const lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        use_native: true 
    });

    


    //------------------------------------------------------------------------//
    //  PUBLIC MODULE FUNCTIONS
    //------------------------------------------------------------------------//
    
    site.Utilities.modalNavOverflow();
    site.Utilities.setLeftOffset();
    site.Utilities.tiltBadge();
    site.Utilities.showMore();
    site.Utilities.formHandler();
    // Animation
    site.Animation.registerGsap();
    if (mediaQueries.xl.matches) {
        site.Animation.smoothScrolling(mediaQueries);
    }
    site.Animation.speedCharacteristics();
    site.Animation.pinnedNavItems(mediaQueries);
    site.Animation.popIn();
    site.Animation.skewElement();
    site.Animation.slideDown();
    site.Animation.slideUp();
    site.Animation.slideLeft();
    site.Animation.slideRight();
    site.Animation.spinInLeft();
    site.Animation.spinInRight();
    site.Animation.staggerItems();
    site.Animation.staggerItemsLeft();
    site.Animation.gradientMesh();
    // site.Animation.marquee();
    site.Animation.staticOrbit();
    site.Animation.statBlocks();
    site.Utilities.anchorLinking();

    
    // Check DOM for images loaded via dynamically and update Lazyload instance
    if (lazyLoadInstance) {
        lazyLoadInstance.update();
    }
    
    
    window,addEventListener('load', () => {
        site.Utilities.loadWidgetScripts();
    })
    window,addEventListener('DOMContentLoaded', () => {
        site.Animation.marquee();
    })

    //------------------------------------------------------------------------//
    // WINDOW RESIZE FUNCTIONS
    //------------------------------------------------------------------------//
    window.addEventListener('resize', debounce(() => {
        site.Utilities.setLeftOffset();
        // site.Animation.pinnedNavItems(mediaQueries);
        // site.Animation.staticOrbit();
        ScrollTrigger.refresh();
    }, 200));
}, false);